export default "__VITE_ASSET__abdd4549__"